import {
    START_LOADING,
    STOP_LOADING,
} from '../actions/types';

const INITIAL_STATE = {
    queue: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case START_LOADING:
            return {
                ...state,
                queue: state.queue.concat(action.payload)
            };
        case STOP_LOADING:
            return {
                ...state,
                queue: state.queue.filter((t, i) => i !== state.queue.indexOf(action.payload))
            };
        default:
            return state;
    }
};
